module.exports = __webpack_public_path__ + "img/kefu2.d00fd6c0.png";